import { GameScatterPickCoconutProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameScatterPickCoconutProperties";
export class ScatterPickCoconutLandscapeProperties extends GameScatterPickCoconutProperties {
    constructor() {
        super();
        this.position.set(973, 512);
        this.scale.set(0.73);
        this.coconutSpineProperties.position.set(0, 130);
    }
}
//# sourceMappingURL=ScatterPickCoconutLandscapeProperties.js.map